import { API_URLS } from "../constants";
import { getRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { STORE } = API_URLS;

//Getting store profile's general details
const getStoreProfileData = (externalId, fromFR) => {
  //If the user is redirecting from FR use the call below
  if (fromFR) {
    return getRequest(`${STORE.GET}/${externalId}`).then(
      (response) => responseHandler.handleServerResponse(response),
      (error) => responseHandler.handleHTTPResponses(error.response)
    );
  }
  //If the user is not redirecting use the call below else
  // eslint-disable-next-line
  else {
    return getRequest(`${STORE.BASE}/${externalId}`).then(
      (response) => responseHandler.handleServerResponse(response),
      (error) => responseHandler.handleHTTPResponses(error.response)
    );
  }
};

// exporting functions for other files
export const individualStoreProfileService = {
  getStoreProfileData,
};
